class ActivityTracker {
    constructor() {
        this.endpoint = `${process.env.REACT_APP_BASE_URL}/logs/activity`;
        this.buffer = [];
        this.flushInterval = 5000; // Flush every 5 seconds
        this.maxBufferSize = 10;
        this.timer = null;
    }

    init() {
        this.timer = setInterval(() => this.flush(), this.flushInterval);

        // Track page views (Single Page App)
        // Use polling instead of MutationObserver on document for better performance
        let lastUrl = window.location.href;
        setInterval(() => {
            const url = window.location.href;
            if (url !== lastUrl) {
                lastUrl = url;
                this.log('page_view', { url });
            }
        }, 1000); // Check every second

        console.log('Activity Tracker initialized');
    }

    log(action, details = {}) {
        const activity = {
            action,
            details,
            url: window.location.href,
            timestamp: new Date().toISOString(),
            user: this.getUserInfo()
        };

        this.buffer.push(activity);

        if (this.buffer.length >= this.maxBufferSize) {
            this.flush();
        }
    }

    async flush() {
        if (this.buffer.length === 0) return;

        const bufferToSend = [...this.buffer];
        this.buffer = [];

        try {
            // Send each activity or batch them if API supports batching
            // The current backend simplistic implementation handles one by one, 
            // but let's just send the last important one or iterate.
            // Ideally backend endpoint should accept array.
            // For now, let's just iterate to be safe with current backend impl.

            for (const activity of bufferToSend) {
                await fetch(this.endpoint, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(activity),
                });
            }
        } catch (error) {
            console.error('Failed to sync activity logs:', error);
            // Optionally put back in buffer? No, let's drop to avoid memory issues
        }
    }

    getUserInfo() {
        try {
            const userStr = localStorage.getItem('user');
            if (userStr) {
                const user = JSON.parse(userStr);
                return { id: user.id || user._id, email: user.email };
            }
        } catch (e) {
            // Ignore
        }
        return null;
    }
}

export const activityTracker = new ActivityTracker();
